import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ServiceCard from './components/ServiceCard'
import Landing from './pages/Landing'
import Generator from './pages/Generator'
import Validator from './pages/Validator'
import GoogleAnalytics from './components/GoogleAnalytics'

const App: React.FC = () => {
  return (
    <Router>
      <GoogleAnalytics />
      <div className="min-h-screen bg-surface-light">
        <Header />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/generator" element={<Generator />} />
          <Route path="/validator" element={<Validator />} />
        </Routes>
        <ServiceCard />
        <Footer />
      </div>
    </Router>
  )
}

export default App 